import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { DischargedProvider } from "../../context/DischargedContext";
import DischargedPanel from "./DischargedPanel";

const DischargedPage = () => {
  const { t } = useTranslation();

  return (
    <DischargedProvider>
      <Box sx={{ p: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
          {t("nav.discharged", "Discharged")}
        </Typography>
        <DischargedPanel />
      </Box>
    </DischargedProvider>
  );
};

export default DischargedPage;
